import { render, staticRenderFns } from "./PlacesSearch.vue?vue&type=template&id=52ceefc4&scoped=true&"
import script from "./PlacesSearch.vue?vue&type=script&lang=js&"
export * from "./PlacesSearch.vue?vue&type=script&lang=js&"
import style0 from "./PlacesSearch.vue?vue&type=style&index=0&id=52ceefc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ceefc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ceefc4')) {
      api.createRecord('52ceefc4', component.options)
    } else {
      api.reload('52ceefc4', component.options)
    }
    module.hot.accept("./PlacesSearch.vue?vue&type=template&id=52ceefc4&scoped=true&", function () {
      api.rerender('52ceefc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/places/PlacesSearch.vue"
export default component.exports